import { render, staticRenderFns } from "./Skill.vue?vue&type=template&id=e4a06caa&"
import script from "./Skill.vue?vue&type=script&lang=js&"
export * from "./Skill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports